import { css } from "@microsoft/fast-element";
import { heightNumber, paddingNumber, spacingNumber } from "../../styles/size";
import { getToken, neutralForegroundRest, neutralInputFillRest, neutralStrokeRest } from "../../design-tokens";
import { display } from "../../foundation/display";

export const listboxWizardStyles = css`
    ${display('block')} :host {
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralStrokeRest} !important;
        border-radius: calc(${getToken('space-input-corner-radius')} * 1px);
        min-height: calc(${heightNumber} * 1px);

        color: ${neutralForegroundRest};
        background: ${neutralInputFillRest};
        box-shadow: 0 0 calc(${getToken('space-input-shadow')} * 1px) 0 rgba(0, 0, 0, 0.1);
    }

    natgen-stack {
        min-height: calc(${heightNumber} * 1px);
        align-items: center;
        padding: 1ch;
        box-sizing: border-box;
    }

    ::slotted(*) {
        display: none;
    }

    ::slotted(.active) {
        display: block;
        width: 100%;
    }
`;
